<div class="scrap-collections-list-container">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Scrap Collections List</h1>
        <p>View and manage all scrap collections and customer care feedback queue</p>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <button class="tab-btn" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')">
      <i class="fas fa-list"></i> All Collections
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'voucher'" (click)="setActiveTab('voucher')">
      <i class="fas fa-ticket-alt"></i> Voucher Collections
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'feedback'" (click)="setActiveTab('feedback')">
      <i class="fas fa-comments"></i> Feedback Queue
    </button>
  </div>

  <!-- Filters -->
  <div class="filters-section">
    <div class="filter-header">
      <h3><i class="fas fa-filter"></i> Filter Scrap Collections</h3>
      <button class="clear-filters-btn" (click)="clearFilters()" [disabled]="!hasActiveFilters() || loading">
        <i class="fas fa-times"></i> Clear Filters
      </button>
    </div>

    <div class="filters-grid">
      <div class="filter-group">
        <label for="dateFrom">From Date:</label>
        <input type="date" id="dateFrom" [(ngModel)]="filters.dateFrom"
          class="filter-input">
      </div>

      <div class="filter-group">
        <label for="dateTo">To Date:</label>
        <input type="date" id="dateTo" [(ngModel)]="filters.dateTo" class="filter-input">
      </div>

      <div class="filter-group">
        <label for="zoneFilter">Zone:</label>
        <select id="zoneFilter" [(ngModel)]="filters.geoZoneId" class="filter-select">
          <option value="">All Zones</option>
          <option *ngFor="let zone of zones" [value]="zone.id">
            {{ zone.name }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label for="agentFilter">Agent:</label>
        <select id="agentFilter" [(ngModel)]="filters.agentId" class="filter-select">
          <option value="">All Agents</option>
          <option *ngFor="let agent of agents" [value]="agent.agentId">
            {{ agent.name }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label for="customerNameFilter">Customer Name:</label>
        <input type="text" id="customerNameFilter" [(ngModel)]="filters.customerName"
          placeholder="Search by customer name..." class="filter-input">
      </div>

      <div class="filter-group">
        <label for="phoneFilter">Phone Number:</label>
        <input type="text" id="phoneFilter" [(ngModel)]="filters.phoneNumber" placeholder="Search by phone number..."
          class="filter-input">
      </div>

      <div class="filter-group" *ngIf="activeTab === 'all'">
        <label for="paymentMethodFilter">Payment Method:</label>
        <select id="paymentMethodFilter" [(ngModel)]="filters.paymentMethod"
          class="filter-select">
          <option value="all">All</option>
          <option value="voucher">Voucher Only</option>
        </select>
      </div>

      <div class="filter-group" *ngIf="activeTab !== 'feedback'">
        <label for="voucherSettlementStatusFilter">Voucher Settlement:</label>
        <select id="voucherSettlementStatusFilter" [(ngModel)]="filters.voucherSettlementStatus"
          class="filter-select">
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="settled">Settled</option>
        </select>
      </div>

      <div class="filter-group" *ngIf="activeTab === 'feedback'">
        <label for="feedbackStatusFilter">Feedback Status:</label>
        <select id="feedbackStatusFilter" [(ngModel)]="filters.feedbackStatus" class="filter-select">
          <option value="all">All Statuses</option>
          <option value="Pending">Pending Call</option>
          <option value="Completed">Completed</option>
          <option value="Skipped">Skipped</option>
        </select>
      </div>

      <div class="filter-actions">
        <button class="apply-filters-btn" (click)="applyFilters()" [disabled]="loading">
          <i class="fas fa-search"></i> Apply Filters
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading scrap collections...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && errorMessage" class="error-container">
    <i class="fas fa-exclamation-triangle"></i>
    <p>{{ errorMessage }}</p>
    <button class="retry-btn" (click)="loadScrapCollections()">Retry</button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !errorMessage && scrapCollections.length === 0" class="empty-container">
    <i class="fas fa-inbox"></i>
    <h3>No Scrap Collections Found</h3>
    <p *ngIf="hasActiveFilters()">Try adjusting your filters to see more results.</p>
    <p *ngIf="!hasActiveFilters() && activeTab === 'feedback'">There are currently no scrap collections tagged for customer care feedback.</p>
  </div>

  <!-- Action Bar (for Batch Settlement in Voucher Tab) -->
  <div *ngIf="!loading && activeTab === 'voucher' && selectedCollectionIds.size > 0" class="action-bar animate-fade-in">
    <div class="action-bar-info">
      <span class="selected-count">
        <i class="fas fa-check-square"></i> {{ selectedCollectionIds.size }} collection(s) selected
      </span>
      <span class="selected-agent" *ngIf="selectedAgentId">
        Agent: <strong>{{ getAgentName(selectedAgentId) }}</strong>
      </span>
      <span class="selected-amount">
        Total Amount: <strong>{{ formatCurrency(getTotalSelectedAmount()) }}</strong>
      </span>
    </div>
    <div class="action-bar-buttons">
      <button class="btn-settle-batch" (click)="openSettlementModal()">
        <i class="fas fa-handshake"></i> Update Settlement Status
      </button>
    </div>
  </div>

  <!-- Scrap Collections Table -->
  <div *ngIf="!loading && scrapCollections.length > 0" class="table-container desktop-table-container">
    <div class="table-wrapper">
      <table class="scrap-collections-table">
        <thead>
          <tr>
            <th class="checkbox-col" *ngIf="activeTab === 'voucher'">
              <div class="checkbox-container">
                <input type="checkbox" class="custom-checkbox" [checked]="isAllSelected()" (change)="selectAll($event)"
                  [disabled]="!hasVoucherCollections()">
              </div>
            </th>
            <th>Customer Name</th>
            <th>Date</th>
            <th *ngIf="activeTab === 'voucher'">Settlement Date</th>
            <th>Agent Name</th>
            <th>Zone</th>
            <th>Items</th>
            <th>Grand Total</th>
            <th *ngIf="activeTab !== 'feedback'">Payment</th>
            <th *ngIf="activeTab !== 'feedback'">Settlement</th>
            <th *ngIf="activeTab === 'feedback'">Feedback Reason</th>
            <th *ngIf="activeTab === 'feedback'" class="feedback-snapshot-header">Feedback Snapshot</th>
            <th *ngIf="activeTab === 'feedback'">Call Status</th>
            <th>Report</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let collection of scrapCollections" class="collection-row"
            [ngClass]="getRowClass(collection)">
            <td class="checkbox-col" *ngIf="activeTab === 'voucher'">
              <div class="checkbox-container" *ngIf="isPendingSettlement(collection)">
                <input type="checkbox" class="custom-checkbox" [checked]="isSelected(collection.id)"
                  (change)="toggleSelection(collection.id)">
              </div>
            </td>
            <td class="customer-name">
              <div>{{ collection.customerName || 'N/A' }}</div>
              <div class="text-xs text-gray-500">{{ collection.customerPhoneNumber }}</div>
            </td>
            <td class="date">{{ formatDate(collection.date) }}</td>
            <td *ngIf="activeTab === 'voucher'" class="collection-date">{{ formatDate(collection.voucherSettlementDate) }}</td>
            <td class="agent-name">{{ collection.agentDetails.name || 'N/A' }}</td>
            <td class="zone">{{ getZoneName(collection.geoZoneId) }}</td>
            <td class="total-items">{{ collection.totalItems }}</td>
            <td class="grand-total">{{ formatCurrency(collection.grandTotal) }}</td>
            
            <!-- Standard Tab Payment & Settlement -->
            <td *ngIf="activeTab !== 'feedback'" class="payment-method">
              <span class="payment-badge"
                [class.payment-voucher]="collection.paymentMethod === 5 || collection.paymentMethod === '5'">
                {{ getPaymentMethodName(collection.paymentMethod) }}
              </span>
            </td>
            <td *ngIf="activeTab !== 'feedback'" class="settlement-status">
              <span *ngIf="collection.paymentMethod === 5 || collection.paymentMethod === '5'" class="settlement-badge"
                [ngClass]="{
                      'status-pending': collection.voucherSettlementStatus === VoucherSettlementStatus.Pending || collection.voucherSettlementStatus === undefined || collection.voucherSettlementStatus === null,
                      'status-settled': collection.voucherSettlementStatus === VoucherSettlementStatus.Settled,
                      'status-rejected': collection.voucherSettlementStatus === VoucherSettlementStatus.Rejected
                    }">
                {{ getVoucherSettlementStatusName(collection.voucherSettlementStatus) }}
              </span>
              <span *ngIf="collection.paymentMethod !== 5 && collection.paymentMethod !== '5'"
                class="text-gray-400">N/A</span>
            </td>

            <!-- Feedback Tab Columns -->
            <td *ngIf="activeTab === 'feedback'" class="feedback-reason">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-200">
                <i class="fas fa-tag mr-1 text-[10px]"></i>
                {{ collection.feedbackDetails?.feedbackReason || 'Feedback Required' }}
              </span>
            </td>
            <td *ngIf="activeTab === 'feedback'" class="feedback-snapshot-cell">
              <div class="feedback-snapshot-content">
                <!-- Happiness Index -->
                <div class="happiness-index-badge-row flex items-center gap-1.5 flex-wrap">
                  <span *ngIf="collection.feedbackDetails?.happinessIndex !== null && collection.feedbackDetails?.happinessIndex !== undefined"
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold shadow-sm"
                    [ngClass]="{
                      'bg-emerald-100 text-emerald-800 border border-emerald-300': collection.feedbackDetails!.happinessIndex! >= 8,
                      'bg-amber-100 text-amber-800 border border-amber-300': collection.feedbackDetails!.happinessIndex! >= 5 && collection.feedbackDetails!.happinessIndex! < 8,
                      'bg-rose-100 text-rose-800 border border-rose-300': collection.feedbackDetails!.happinessIndex! < 5
                    }">
                    <i class="fas fa-star mr-1 text-xs"></i>
                    {{ collection.feedbackDetails?.happinessIndex }} / 10
                  </span>
                  <span *ngIf="collection.feedbackDetails?.happinessIndex === null || collection.feedbackDetails?.happinessIndex === undefined"
                    class="text-gray-400 italic text-xs">
                    Not rated
                  </span>

                  <!-- Answered 'No' Alert Badge -->
                  <span *ngIf="hasCustomerAnsweredNo(collection)"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold bg-rose-600 text-white shadow-sm"
                    title="Customer answered 'No' to one or more questions">
                    <i class="fas fa-exclamation-triangle mr-1 text-[10px]"></i>
                    Has "No" Answer
                  </span>
                </div>

                <!-- Questions Answered 'No' List -->
                <div *ngIf="getNegativeQuestions(collection).length > 0" class="negative-questions-box mt-1.5">
                  <div *ngFor="let q of getNegativeQuestions(collection)"
                    class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[11px] font-semibold bg-rose-100 text-rose-900 border border-rose-200 mr-1 mb-1 max-w-full"
                    [title]="q.questionText + ': No'">
                    <i class="fas fa-times-circle text-rose-600 text-[10px] flex-shrink-0"></i>
                    <span class="truncate max-w-[200px]">{{ q.questionText }}: <strong>No</strong></span>
                  </div>
                </div>

                <!-- Questions Passed (All Yes) -->
                <div *ngIf="!hasCustomerAnsweredNo(collection) && hasPositiveQuestions(collection)" class="positive-questions-box mt-1">
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200">
                    <i class="fas fa-check-circle mr-1 text-emerald-600 text-[10px]"></i>
                    All Questions Passed (Yes)
                  </span>
                </div>

                <!-- Customer Comments Preview -->
                <div *ngIf="collection.feedbackDetails?.customerComments"
                  class="customer-comment-preview text-xs text-gray-600 italic flex items-center gap-1 max-w-[220px] truncate mt-1"
                  [title]="'Customer Comment: ' + collection.feedbackDetails?.customerComments">
                  <i class="fas fa-comment-dots text-gray-400 text-[10px] flex-shrink-0"></i>
                  <span class="truncate">"{{ collection.feedbackDetails?.customerComments }}"</span>
                </div>

              </div>
            </td>
            <td *ngIf="activeTab === 'feedback'" class="feedback-status">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold"
                [ngClass]="{
                  'bg-rose-100 text-rose-800': collection.feedbackDetails?.feedbackStatus === 'Pending' || !collection.feedbackDetails?.feedbackStatus,
                  'bg-emerald-100 text-emerald-800': collection.feedbackDetails?.feedbackStatus === 'Completed',
                  'bg-gray-100 text-gray-700': collection.feedbackDetails?.feedbackStatus === 'Skipped'
                }">
                {{ collection.feedbackDetails?.feedbackStatus || 'Pending' }}
              </span>
            </td>

            <td class="report-cell">
              <a *ngIf="collection.downloadCollectionReport" [href]="collection.downloadCollectionReport"
                target="_blank" class="download-report-btn" title="Download Collection Report">
                <i class="fas fa-download"></i>
              </a>
              <span *ngIf="!collection.downloadCollectionReport" class="text-gray-400">N/A</span>
            </td>
            <td class="actions-cell">
              <button class="view-collection-btn" (click)="viewCollectionDetails(collection)"
                title="View Collection Details">
                <i class="fas fa-eye"></i>
              </button>
              <button *ngIf="activeTab === 'voucher'" class="view-settlement-btn" (click)="openSettlementDetailsModal(collection)"
                title="View Settlement Details">
                <i class="fas fa-handshake"></i>
              </button>
              <button *ngIf="activeTab === 'feedback'" class="btn-feedback text-xs px-2.5 py-1.5 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700 font-bold hover:bg-emerald-100 transition-colors flex items-center gap-1" (click)="openFeedbackModal(collection)"
                title="Log Customer Care Call Feedback">
                <i class="fas fa-headset text-emerald-600"></i>
                <span>Log Feedback</span>
              </button>
              <button *ngIf="activeTab !== 'feedback'" class="btn-tag-toggle text-xs px-2.5 py-1.5 rounded-lg border font-semibold transition-all duration-200 flex items-center gap-1.5"
                [ngClass]="collection.requiresFeedback ? 'bg-amber-50 border-amber-300 text-amber-800 hover:bg-amber-100' : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-emerald-50 hover:border-emerald-300 hover:text-emerald-700'"
                (click)="toggleManualFeedbackTag(collection)"
                [title]="collection.requiresFeedback ? 'Remove from Feedback Queue' : 'Add to Feedback Queue'">
                <i class="fas" [ngClass]="collection.requiresFeedback ? 'fa-bookmark text-amber-600' : 'fa-plus-circle text-emerald-600'"></i>
                <span>{{ collection.requiresFeedback ? 'Tagged' : 'Add to Queue' }}</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Scrap Collections Mobile Cards View -->
  <div *ngIf="!loading && scrapCollections.length > 0" class="mobile-cards-container">
    <div *ngFor="let collection of scrapCollections"
      class="collection-card"
      [ngClass]="getRowClass(collection)">
      
      <!-- Card Header -->
      <div class="card-header">
        <div class="card-header-left flex items-start gap-2.5">
          <div class="checkbox-container pt-1" *ngIf="activeTab === 'voucher' && isPendingSettlement(collection)">
            <input type="checkbox" class="custom-checkbox" [checked]="isSelected(collection.id)"
              (change)="toggleSelection(collection.id)">
          </div>
          <div>
            <h3 class="text-base font-bold text-gray-900 m-0">{{ collection.customerName || 'N/A' }}</h3>
            <a *ngIf="collection.customerPhoneNumber" [href]="'tel:' + collection.customerPhoneNumber"
               class="text-xs text-emerald-700 font-semibold inline-flex items-center gap-1 mt-0.5 hover:underline">
              <i class="fas fa-phone-alt text-[10px]"></i> {{ collection.customerPhoneNumber }}
            </a>
          </div>
        </div>
        <div class="text-right">
          <div class="text-base font-bold text-emerald-800">{{ formatCurrency(collection.grandTotal) }}</div>
          <div class="text-[11px] text-gray-500">{{ formatDate(collection.date) }}</div>
        </div>
      </div>

      <!-- Card Content -->
      <div class="card-content">
        <div class="info-row">
          <span class="label">Agent & Zone:</span>
          <span class="value">{{ collection.agentDetails.name || 'N/A' }} • {{ getZoneName(collection.geoZoneId) }}</span>
        </div>

        <div class="info-row">
          <span class="label">Total Items:</span>
          <span class="value">{{ collection.totalItems }}</span>
        </div>

        <!-- Voucher Tab: Settlement Date -->
        <div class="info-row" *ngIf="activeTab === 'voucher' && collection.voucherSettlementDate">
          <span class="label">Settlement Date:</span>
          <span class="value">{{ formatDate(collection.voucherSettlementDate) }}</span>
        </div>

        <!-- Standard Tab Payment & Settlement -->
        <div class="info-row" *ngIf="activeTab !== 'feedback'">
          <span class="label">Payment:</span>
          <span class="value">
            <span class="payment-badge"
              [class.payment-voucher]="collection.paymentMethod === 5 || collection.paymentMethod === '5'">
              {{ getPaymentMethodName(collection.paymentMethod) }}
            </span>
          </span>
        </div>

        <div class="info-row" *ngIf="activeTab !== 'feedback'">
          <span class="label">Settlement:</span>
          <span class="value">
            <span *ngIf="collection.paymentMethod === 5 || collection.paymentMethod === '5'" class="settlement-badge"
              [ngClass]="{
                'status-pending': collection.voucherSettlementStatus === VoucherSettlementStatus.Pending || collection.voucherSettlementStatus === undefined || collection.voucherSettlementStatus === null,
                'status-settled': collection.voucherSettlementStatus === VoucherSettlementStatus.Settled,
                'status-rejected': collection.voucherSettlementStatus === VoucherSettlementStatus.Rejected
              }">
              {{ getVoucherSettlementStatusName(collection.voucherSettlementStatus) }}
            </span>
            <span *ngIf="collection.paymentMethod !== 5 && collection.paymentMethod !== '5'" class="text-gray-400">N/A</span>
          </span>
        </div>

        <!-- Feedback Tab Details -->
        <div *ngIf="activeTab === 'feedback'" class="space-y-2.5 pt-2 border-t border-gray-150">
          <div class="flex items-center justify-between gap-2 flex-wrap">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-200">
              <i class="fas fa-tag mr-1 text-[10px]"></i>
              {{ collection.feedbackDetails?.feedbackReason || 'Feedback Required' }}
            </span>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold"
              [ngClass]="{
                'bg-rose-100 text-rose-800': collection.feedbackDetails?.feedbackStatus === 'Pending' || !collection.feedbackDetails?.feedbackStatus,
                'bg-emerald-100 text-emerald-800': collection.feedbackDetails?.feedbackStatus === 'Completed',
                'bg-gray-100 text-gray-700': collection.feedbackDetails?.feedbackStatus === 'Skipped'
              }">
              <i class="fas fa-circle text-[7px] mr-1"></i>
              {{ collection.feedbackDetails?.feedbackStatus || 'Pending' }}
            </span>
          </div>

          <!-- Feedback Snapshot in Card -->
          <div class="p-3 bg-white rounded-xl border border-gray-200 space-y-2 shadow-xs">
            <div class="flex items-center justify-between">
              <span class="text-xs font-bold text-gray-700">Happiness Index:</span>
              <span *ngIf="collection.feedbackDetails?.happinessIndex !== null && collection.feedbackDetails?.happinessIndex !== undefined"
                class="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-bold shadow-sm"
                [ngClass]="{
                  'bg-emerald-100 text-emerald-800 border border-emerald-300': collection.feedbackDetails!.happinessIndex! >= 8,
                  'bg-amber-100 text-amber-800 border border-amber-300': collection.feedbackDetails!.happinessIndex! >= 5 && collection.feedbackDetails!.happinessIndex! < 8,
                  'bg-rose-100 text-rose-800 border border-rose-300': collection.feedbackDetails!.happinessIndex! < 5
                }">
                <i class="fas fa-star mr-1 text-xs"></i>
                {{ collection.feedbackDetails?.happinessIndex }} / 10
              </span>
              <span *ngIf="collection.feedbackDetails?.happinessIndex === null || collection.feedbackDetails?.happinessIndex === undefined"
                class="text-gray-400 italic text-xs">
                Not rated
              </span>
            </div>

            <!-- Negative Questions Alert -->
            <div *ngIf="hasCustomerAnsweredNo(collection)" class="space-y-1.5 pt-1 border-t border-rose-100">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold bg-rose-600 text-white shadow-sm">
                <i class="fas fa-exclamation-triangle mr-1 text-[10px]"></i>
                Has "No" Answer
              </span>
              <div *ngFor="let q of getNegativeQuestions(collection)"
                class="text-xs font-semibold text-rose-900 bg-rose-100 border border-rose-200 rounded-lg p-2 flex items-start gap-1.5">
                <i class="fas fa-times-circle text-rose-600 mt-0.5 flex-shrink-0"></i>
                <span>{{ q.questionText }}: <strong>No</strong></span>
              </div>
            </div>

            <!-- All Passed (Yes) -->
            <div *ngIf="!hasCustomerAnsweredNo(collection) && hasPositiveQuestions(collection)">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-emerald-50 text-emerald-700 border border-emerald-200">
                <i class="fas fa-check-circle mr-1 text-emerald-600"></i> All Questions Passed (Yes)
              </span>
            </div>

            <!-- Customer Comments -->
            <div *ngIf="collection.feedbackDetails?.customerComments"
              class="text-xs text-gray-700 italic bg-gray-50 p-2.5 rounded-lg border border-gray-200 mt-1">
              <i class="fas fa-quote-left mr-1 text-gray-400 text-[10px]"></i>"{{ collection.feedbackDetails?.customerComments }}"
            </div>
          </div>
        </div>
      </div>

      <!-- Card Actions -->
      <div class="card-actions">
        <!-- In Feedback Tab: Log Feedback is Primary -->
        <div *ngIf="activeTab === 'feedback'" class="space-y-2">
          <button type="button" class="btn-feedback-mobile" (click)="openFeedbackModal(collection)">
            <i class="fas fa-headset mr-1.5"></i> Log Feedback
          </button>
          <div class="flex gap-2">
            <button type="button" class="btn-secondary-mobile" (click)="viewCollectionDetails(collection)">
              <i class="fas fa-eye mr-1"></i> Details
            </button>
            <a *ngIf="collection.downloadCollectionReport" [href]="collection.downloadCollectionReport"
               target="_blank" class="btn-secondary-mobile">
              <i class="fas fa-download mr-1"></i> Report
            </a>
          </div>
        </div>

        <!-- In Standard Tabs -->
        <div *ngIf="activeTab !== 'feedback'" class="space-y-2">
          <button type="button" class="view-collection-btn-mobile" (click)="viewCollectionDetails(collection)">
            <i class="fas fa-eye mr-2"></i> View Details
          </button>
          <div class="flex gap-2">
            <button *ngIf="activeTab === 'voucher'" type="button" class="btn-secondary-mobile"
              (click)="openSettlementDetailsModal(collection)">
              <i class="fas fa-handshake mr-1"></i> Settlement
            </button>
            <a *ngIf="collection.downloadCollectionReport" [href]="collection.downloadCollectionReport"
               target="_blank" class="btn-secondary-mobile">
              <i class="fas fa-download mr-1"></i> Report
            </a>
            <button type="button" class="btn-secondary-mobile"
              (click)="toggleManualFeedbackTag(collection)">
              <i class="fas mr-1" [ngClass]="collection.requiresFeedback ? 'fa-bookmark text-amber-600' : 'fa-plus-circle text-emerald-600'"></i>
              <span>{{ collection.requiresFeedback ? 'Tagged' : 'Queue' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <app-pagination *ngIf="!loading && scrapCollections.length > 0" [page]="currentPage"
    [totalPages]="totalPages" [pageSize]="pageSize" (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </app-pagination>

  <!-- Settlement Modal -->
  <div *ngIf="showSettlementModal" class="modal-overlay" (click)="closeSettlementModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2><i class="fas fa-handshake"></i> Update Voucher Settlement Status</h2>
        <button class="modal-close-btn" (click)="closeSettlementModal()" [disabled]="settling">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="modal-summary">
          <p>Selected Collections: <strong>{{ selectedCollectionIds.size }}</strong></p>
          <p>Agent Name: <strong>{{ getAgentName(selectedAgentId || '') }}</strong></p>
          <p>Total Amount: <strong>{{ formatCurrency(getTotalSelectedAmount()) }}</strong></p>
        </div>

        <form (ngSubmit)="confirmSettlement()">
          <div *ngIf="settlementErrorMessage" class="alert alert-danger" style="color: #ef4444; background-color: #fee2e2; border: 1px solid #fca5a5; padding: 0.75rem; border-radius: 0.375rem; margin-bottom: 1rem; font-size: 0.875rem;">
            <i class="fas fa-exclamation-circle"></i> {{ settlementErrorMessage }}
          </div>
          <div class="form-group">
            <label for="settlementDate">Date of Settlement:</label>
            <input type="date" id="settlementDate" [(ngModel)]="dateOfCollection" name="dateOfCollection"
              class="form-control" [disabled]="settling" required>
          </div>

          <div class="form-group">
            <label for="settlementStatus">Settlement Status:</label>
            <select id="settlementStatus" [(ngModel)]="settlementStatus" name="settlementStatus"
              class="form-control" [disabled]="settling">
              <option [ngValue]="VoucherSettlementStatus.Settled">Settled</option>
              <option [ngValue]="VoucherSettlementStatus.Rejected">Rejected</option>
          </select>
        </div>

        <div class="form-group" *ngIf="settlementStatus === VoucherSettlementStatus.Settled">
          <small style="font-size: 0.85rem; color: #059669; display: block; background-color: #ecfdf5; padding: 0.5rem 0.75rem; border-radius: 6px; border: 1px solid #a7f3d0;">
            <i class="fas fa-info-circle"></i> A Receipt (pay in) of {{ formatCurrency(getTotalSelectedAmount()) }} will be automatically recorded to the Petty Cash account upon settlement.
          </small>
        </div>

          <div class="form-group">
            <label for="settlementNotes">Notes (Optional):</label>
            <textarea id="settlementNotes" [(ngModel)]="settlementNotes" name="settlementNotes"
              class="form-control" rows="3" placeholder="Enter any notes about this settlement..."
              [disabled]="settling"></textarea>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn-cancel" (click)="closeSettlementModal()" [disabled]="settling">
              Cancel
            </button>
            <button type="submit" class="btn-confirm-settle" [disabled]="settling">
              <span *ngIf="settling">
                <i class="fas fa-spinner fa-spin"></i> Processing...
              </span>
              <span *ngIf="!settling">
                <i class="fas fa-check-circle"></i> Confirm Settlement
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Customer Care Call Feedback Bottom Sheet / Modal -->
  <div *ngIf="showFeedbackModal && selectedFeedbackCollection" class="feedback-sheet-overlay" (click)="closeFeedbackModal()">
    <div class="feedback-sheet-container" (click)="$event.stopPropagation()">
      <!-- Mobile Drag Handle -->
      <div class="feedback-sheet-handle-bar">
        <div class="feedback-sheet-handle"></div>
      </div>

      <!-- Header (Sticky at top) -->
      <div class="feedback-sheet-header">
        <div class="flex items-center justify-between">
          <h2 class="text-base sm:text-lg font-bold flex items-center gap-2 m-0 text-white">
            <i class="fas fa-headset text-emerald-300"></i>
            <span>Customer Care Call Feedback</span>
          </h2>
          <button type="button" class="feedback-sheet-close-btn" (click)="closeFeedbackModal()" [disabled]="submittingFeedback">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Collection Quick Info Strip -->
        <div class="feedback-sheet-subinfo">
          <span><i class="fas fa-user mr-1 text-emerald-200"></i>{{ selectedFeedbackCollection.customerName }}</span>
          <span><i class="fas fa-phone mr-1 text-emerald-200"></i>{{ selectedFeedbackCollection.customerPhoneNumber }}</span>
          <span class="hidden sm:inline"><i class="fas fa-truck mr-1 text-emerald-200"></i>{{ selectedFeedbackCollection.agentDetails.name }}</span>
          <span><i class="fas fa-rupee-sign mr-1 text-emerald-200"></i>{{ formatCurrency(selectedFeedbackCollection.grandTotal) }}</span>
        </div>

        <div *ngIf="selectedFeedbackCollection.feedbackDetails?.feedbackReason" class="feedback-reason-chip">
          <i class="fas fa-tag mr-1 text-[10px]"></i>
          <span>Tag: {{ selectedFeedbackCollection.feedbackDetails?.feedbackReason }}</span>
        </div>
      </div>

      <!-- Form with Scrollable Body and Sticky Footer -->
      <form (ngSubmit)="saveFeedback()" class="feedback-sheet-form">
        <div class="feedback-sheet-body">
          <!-- Happiness Index Score (1-10) -->
          <div class="feedback-form-section">
            <label class="block text-xs font-bold uppercase tracking-wider text-gray-700 mb-2">
              Customer Happiness Index (1 - 10 Score)
            </label>
            <div class="grid grid-cols-5 sm:grid-cols-10 gap-1.5">
              <button type="button" *ngFor="let score of [1,2,3,4,5,6,7,8,9,10]"
                (click)="feedbackHappinessIndex = score"
                [ngClass]="feedbackHappinessIndex === score ? 'bg-emerald-600 text-white font-bold scale-105 shadow-md ring-2 ring-emerald-400' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                class="h-10 rounded-lg text-sm font-semibold transition-all duration-150 border border-gray-200 flex items-center justify-center">
                {{ score }}
              </button>
            </div>
          </div>

          <!-- Dynamic Questions Section -->
          <div *ngIf="globalFeedbackQuestions && globalFeedbackQuestions.length > 0" class="feedback-form-section pt-3 border-t border-gray-150">
            <h3 class="text-xs font-bold uppercase tracking-wider text-gray-700 mb-2">Survey Questions</h3>

            <div class="space-y-3">
              <div *ngFor="let q of globalFeedbackQuestions" class="bg-gray-50 p-3 border border-gray-200 rounded-xl space-y-2">
                <label class="block text-xs font-semibold text-gray-800">{{ q.questionText }}</label>

                <!-- Yes/No Question with touch button pills -->
                <div *ngIf="q.questionType === 'YesNo'" class="grid grid-cols-2 gap-2">
                  <button type="button"
                    (click)="surveyQuestionAnswers[q.id] = 'Yes'"
                    [ngClass]="surveyQuestionAnswers[q.id] === 'Yes' ? 'bg-emerald-600 text-white font-bold shadow-sm' : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'"
                    class="py-2.5 px-3 rounded-lg text-xs font-bold flex items-center justify-center gap-1.5 transition-all">
                    <i class="fas fa-check text-[11px]"></i> Yes
                  </button>
                  <button type="button"
                    (click)="surveyQuestionAnswers[q.id] = 'No'"
                    [ngClass]="surveyQuestionAnswers[q.id] === 'No' ? 'bg-rose-600 text-white font-bold shadow-sm' : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'"
                    class="py-2.5 px-3 rounded-lg text-xs font-bold flex items-center justify-center gap-1.5 transition-all">
                    <i class="fas fa-times text-[11px]"></i> No
                  </button>
                </div>

                <!-- Open-ended Text Question -->
                <div *ngIf="q.questionType === 'Text'">
                  <input type="text" [(ngModel)]="surveyQuestionAnswers[q.id]" [name]="'q_' + q.id" placeholder="Enter customer response..." class="w-full border border-gray-200 rounded-lg p-2.5 text-xs bg-white focus:border-emerald-500 focus:outline-none">
                </div>

                <!-- Rating Question -->
                <div *ngIf="q.questionType === 'Rating'" class="grid grid-cols-5 gap-1.5">
                  <button type="button" *ngFor="let r of [1,2,3,4,5]"
                    (click)="surveyQuestionAnswers[q.id] = r.toString()"
                    [ngClass]="surveyQuestionAnswers[q.id] === r.toString() ? 'bg-amber-500 text-white font-bold shadow-sm' : 'bg-white text-gray-700 border border-gray-200'"
                    class="h-9 rounded-lg text-xs font-bold flex items-center justify-center gap-1">
                    {{ r }} <i class="fas fa-star text-[10px]"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Customer Comments -->
          <div class="feedback-form-section">
            <label class="block text-xs font-semibold text-gray-700 mb-1">Customer Verbal Feedback Comments</label>
            <textarea [(ngModel)]="feedbackCustomerComments" name="feedbackCustomerComments" rows="3" placeholder="Direct comments provided by customer..." class="w-full border border-gray-200 rounded-xl p-3 text-xs focus:border-emerald-500 focus:outline-none bg-gray-50 focus:bg-white"></textarea>
          </div>

          <!-- Internal Comments -->
          <div class="feedback-form-section">
            <label class="block text-xs font-semibold text-gray-700 mb-1">Customer Care Agent Internal Notes</label>
            <textarea [(ngModel)]="feedbackInternalComments" name="feedbackInternalComments" rows="2" placeholder="Internal remarks / action items for team..." class="w-full border border-gray-200 rounded-xl p-3 text-xs focus:border-emerald-500 focus:outline-none bg-gray-50 focus:bg-white"></textarea>
          </div>

          <!-- Feedback Status -->
          <div class="feedback-form-section flex items-center justify-between p-3 bg-gray-50 border border-gray-200 rounded-xl">
            <label class="text-xs font-bold text-gray-800">Call Outcome Status</label>
            <select [(ngModel)]="feedbackStatus" name="feedbackStatus" class="border border-gray-200 rounded-lg p-2 text-xs font-semibold bg-white focus:border-emerald-500 focus:outline-none">
              <option value="Completed">Completed</option>
              <option value="Pending">Pending Callback</option>
              <option value="Skipped">Skipped / Unreachable</option>
            </select>
          </div>
        </div>

        <!-- Sticky Bottom Action Bar -->
        <div class="feedback-sheet-footer">
          <button type="button" class="feedback-btn-cancel" (click)="closeFeedbackModal()" [disabled]="submittingFeedback">
            Cancel
          </button>
          <button type="submit" class="feedback-btn-submit" [disabled]="submittingFeedback">
            <span *ngIf="submittingFeedback"><i class="fas fa-spinner fa-spin mr-1.5"></i> Saving...</span>
            <span *ngIf="!submittingFeedback"><i class="fas fa-check mr-1.5"></i> Save Feedback</span>
          </button>
        </div>
      </form>
    </div>
  </div>

</div>